import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import React from "react"
import styled from "styled-components"

import { getCurrentLessonInfo } from "../../../my-courses/operators/getCurrentLessonInfo"
import { Dashboard_mostRecentCourses } from "../../queries/types/Dashboard"
import RecentCourseListButton from "./RecentCourseListButton"

interface Props {
  studentCourse: Dashboard_mostRecentCourses
}

const RecentCourseListItem = ({ studentCourse }: Props) => {
  const { currentLesson, totalLessons } = getCurrentLessonInfo(studentCourse)
  return (
    <Wrapper>
      <Grid container justify="space-between" alignItems="center">
        <Grid item zeroMinWidth md>
          <Typography variant="h6" color="primary">
            <b>{studentCourse.course.title}</b>
          </Typography>
          <Typography>
            <b>{currentLesson}</b> of <b>{totalLessons}</b> lessons done
          </Typography>
          <Typography>
            <i>
              {(() => {
                const legalHours = studentCourse.course.legalHours
                const nonlegalHours = studentCourse.course.nonlegalHours
                const fairhousingHours = studentCourse.course.fairhousingHours

                // Create an array to hold the relevant breakdown
                const breakdown: string[] = []
                if (legalHours > 0) breakdown.push(`${legalHours} Legal`)
                if (nonlegalHours > 0)
                  breakdown.push(`${nonlegalHours} Non-legal`)
                if (fairhousingHours > 0)
                  breakdown.push(`${fairhousingHours} Fair Housing`)

                // Join the breakdown with " / " and render it
                return breakdown.join(" / ")
              })()}
            </i>
          </Typography>
        </Grid>
        <Grid item zeroMinWidth>
          <RecentCourseListButton status={studentCourse.status} />
        </Grid>
      </Grid>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  position: relative;
  overflow: hidden;
  height: 100px;
  padding: 12px;

  img {
    opacity: 0.1;
    position: absolute;
    left: 0px;
    top: 50%;
    transform: translateY(-50%);
  }

  h6 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export default RecentCourseListItem
